  <template>
  <div v-if="hasStreamInfo" id="img-streaming-wrapper">
    <video-player :options="videoOptions" />
  </div>
</template>

<script>
import StreamAPI from "../api/streaming";
import VideoPlayer from "../components/VideoPlayer.vue";
export default {
  name: "Widget",
  components: {
    VideoPlayer,
  },
  props: {
    eventObject: Object,
  },
  data() {
    return {
      fixtureId: this.eventObject.fixtureId,
      imgEventId: 0,
      ip: "server.side",
      streamLink: "",
      authToken: "",
      operatorId: 0,
      timestamp: 0,
      videoLoad: false,
      videoOptions: {
        autoplay: true,
        controls: true,
        fullscreenToggle: true,
        sources: [],
      },
    };
  },
  mounted() {
    if (this.eventObject) {
      this.getMappedEventData(this.eventObject.fixtureId);
    }
  },
  computed: {
    hasStreamInfo() {
      return this.videoLoad;
    },
  },
  methods: {
    getMappedEventData(fixtureId) {
      StreamAPI.getStreamingEvent(fixtureId)
        .then((data) => {
          if (data.responseObject) {
            this.imgEventId = data.responseObject.eventID;

            this.getAuthDetails(this.ip);
          }
        })
        .catch((err) => console.log(err));
    },
    getAuthDetails(ip) {
      StreamAPI.getStreamingAuthDetails(ip)
        .then((data) => {
          this.authToken = data.responseObject.token;
          this.timestamp = data.responseObject.timestamp;
          this.operatorId = data.responseObject.operatorId;

          this.getStreamInfo(
            this.imgEventId,
            this.operatorId,
            this.authToken,
            this.timestamp
          );
        })
        .catch((err) => console.log(err));
    },
    getStreamInfo(imgEventId, operatorId, token, timestamp) {
      // GET request using fetch with error handling
      fetch(
        `https://api.livestreaming.imgarena.com/api/v2/streaming/events/${imgEventId}/stream?operatorId=${operatorId}&auth=${token}&timestamp=${timestamp}&supressErrors=false&format=JSON&thumbnail=false`
      )
        .then(async (response) => {
          const data = await response.json();

          this.streamLink = data.hlsUrl;
          this.videoOptions.sources = [
            {
              src: this.streamLink,
              type: "application/x-mpegURL",
            },
          ];

          this.videoLoad = true;

          // check for error response
          if (!response.ok) {
            // get error message from body or default to response statusText
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
          }
          return data;
        })
        .catch((error) => {
          this.errorMessage = error;
          console.error("There was an error!", error);
        });
    },
  },
  watch: {
    eventObject: {
      handler(newVal, old) {
        if (old.fixtureId !== newVal.fixtureId) {
          this.videoLoad = false;
          this.getMappedEventData(newVal.fixtureId);
        }
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-js {
  /* position: absolute;
    top: 0px;
    left: 0; */
  width: 100vw;
  height: 100%;
}
</style>
